import CacheEnabledApiClient from './CacheEnabledApiClient';
/* global axios */

class LabelsAPI extends CacheEnabledApiClient {
  constructor() {
    super('labels', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'label';
  }

  automationRules(labelId) {
    return axios.get(`${this.url}/${labelId}/automation_rules`);
  }

  createAutomationRule(labelId, rule) {
    return axios.post(`${this.url}/${labelId}/automation_rules`, {
      automation_rule: rule,
    });
  }

  updateAutomationRule(labelId, ruleId, rule) {
    return axios.patch(`${this.url}/${labelId}/automation_rules/${ruleId}`, {
      automation_rule: rule,
    });
  }
}

export default new LabelsAPI();
